import { Close } from '@ankr.com/ui';
import { Typography } from '@mui/material';

import { MarkdownWrapper } from 'modules/strapi/components/MarkdownWrapper';
import { closeTopBanner } from 'modules/strapi/store/strapiSlice';
import { useAppDispatch } from 'store/useAppDispatch';

import { useTopBannerStyles } from './useTopBannerStyles';

export interface TopBannerProps {
  children: string;
  id: string;
  variant?: 'dark' | 'light';
}

export const TopBanner = ({
  children,
  id,
  variant = 'dark',
}: TopBannerProps) => {
  const { classes, cx } = useTopBannerStyles();

  const className = cx(classes.root, classes[variant]);

  const dispatch = useAppDispatch();

  const onCloseIconClick = () => dispatch(closeTopBanner(id));

  // This is necessary to pass properties to the wrapper without typescript errors.
  const wrapperProps = { className: classes.text, variant: 'body3' };

  return (
    <div className={className}>
      <MarkdownWrapper
        options={{
          wrapper: Typography,
          forceWrapper: true,
        }}
        olVariant="body3"
        ulVariant="body3"
        {...wrapperProps}
      >
        {children}
      </MarkdownWrapper>
      <Typography variant="body3" className={classes.text}></Typography>
      <Close
        className={classes.closeIcon}
        onClick={onCloseIconClick}
        size={20}
      />
    </div>
  );
};
